import { getEntityMap } from 'data'

export function getContactUsers(state) {
  return getEntityMap(state, 'ContactUser')
}

export const getOrganizationContactsUpdateState = state => {
  return state.contactUser.get('fetchMyOrganizationContacts')
}
